<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>Video Gallery </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"
            alt="GHRSCF" />
    </div>
</section>
<section class="section section-sm video-gallery section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Video <span>Gallery</span></h2>
        </div>

        <div class="row mb">
            <!-- <div class="col-sm-6 col-md-4">
                <iframe width="100%" height="315" src="https://www.youtube.com/eed/K0pEc5d6OQ8" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>

            <div class="col-sm-6 col-md-4">
                <iframe width="100%" height="315" src="https://www.youtube.com/eed/v0LJ2w-3UcQ" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/2kEHtDA1AFE" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div> -->
            <div class="col-sm-6 col-md-4">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/YZ8GztFzLlY" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/EJZlUS_zHE4" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/AxLaqrxjqNU" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/hn4RK8KBx-4" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/mCeo78jfyP8" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/oJ36FEgFbdg" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/i70GZq1V9xI" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/nSUk9YLB5M0" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/lIZ8KN1mpvI" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/PNOzNI5qaIA" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/ahil5mhZY2o" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/mCeo78jfyP8" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/lxhDyVyAR4U" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/_Krm8OJqnXE" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/CdY5C90dMn4" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/wNXpeQyScF8" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/2EAj2m8XBzE" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/4hLcioiV8JU" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/ZHzIPevE4bA" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/5_tZ6oPWhDM" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/LR7NxOkBpWI" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>

            <div class="col-sm-6 col-md-4">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/2mNtqqUafiE" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/czd2oOgsvlE" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>

            <div class="col-sm-6 col-md-4">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/epVY4t6DPO0" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/dSby_1miUuY" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/dSby_1miUuY" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
        </div>
        <div class="border-line-sm"></div>
        <div class="row mb">
            <div class="col-sm-6 col-md-4">
                <h5>22nd Employees' Annual Sports & Cultural Meet 2026 (NEEV 2026)</h5>
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/9k1_yEfVKaw?si=XasPcvPC5-eJ23qx"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    llowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <h5>21st Employees' Annual Sports & Cultural Meet 2025 (NEEV 2025)</h5>
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/IF9UHNqY8Ww?si=igMD0pRaoLVHzS18"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <h5>20th Employees' Annual Sports & Cultural Meet 2024 (NEEV 2024)</h5>
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/lbCTgHJd8V8?si=W5zL8amgSQb2AFnC"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <h5>Employees' Annual Sports & Cultural Meet 2022 (NEEV 2022)</h5>
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/OAobYbFJWvQ?si=-S7OuFpwGrEJ2qcA"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen></iframe>
            </div>

        </div>
        <div class="border-line-sm"></div>
        <div class="row mb">
            <div class="col-sm-6 col-md-4">
                <h5>Employee Sports Meet 2021 Part-1</h5>
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/EHsOYiSbiVQ" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <h5>Employee Sports Meet 2021 Part-2</h5>
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/byU3ezniOsk" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <h5>Employee Sports Meet 2020 part-1</h5>
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/5VCM80Hu858" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <h5>Employee Sports Meet 2020 part-2</h5>
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/GHLr66GlvQ4" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>

            <div class="col-sm-6 col-md-4">
                <h5>Employee Sports Meet 2020 part-5</h5>
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/0C9ldupmhts" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <h5>Employee Sports Meet 2020 part-4</h5>
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/A_UWx1_i2Uw" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <h5>Employee Sports Meet 2020 part-5</h5>
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/-H936uxZA7o" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>

            <div class="col-sm-6 col-md-4">
                <h5>Employee Sports Meet 2019 part-1</h5>
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/PCNqgNze2wI?start=961"
                    frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <h5>Employee Sports Meet 2019 part-2</h5>
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/1sh52y2Pfg0?start=31"
                    frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col-sm-6 col-md-4">
                <h5>Employee Sports Meet 2019 part-3</h5>
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/qYY1ecs_6T4" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
        </div>
    </div>
</section>
